<template>
  <div id="dashboard-equipes">
    <div class="row align-items-center">
      <div class="col-lg-4">
        <donut-chart :series="dadosDashboard" nivel="2"></donut-chart>
      </div>
      <div class="col-lg-8">
        <tree-map
          nivel="2"
          :series="dadosDashboard"
          @openModal="openModal($event)"
        ></tree-map>
      </div>
      <b-modal
        id="dashboard-equipes-modal"
        v-model="modal.enabled"
        centered
        size="xl"
        hide-footer
      >
        <template #modal-title>
          {{ modal.title }}
          <span class="tag-tipo-equipe">
            {{ tipoEquipeLabel }}
          </span>
          <span v-if="periodo != null" class="tag-tipo-equipe">
            {{ periodo.label }}
          </span>
        </template>

        <div
          class="d-flex justify-content-end align-items-center modal-filtros"
        >
          <ResultadoToggle
            v-model="tipoResultado"
            :disabledMensal="true"
            mensagemMensalDesabilitado="O filtro Mês não está disponível na visualização por equipe."
          />

          <FiltroPrevistoRealizado
            v-if="exibirFiltroPrevistoRealizado"
            v-model="filtroResultadoQuadrimestral"
          />
        </div>
        <v-app class="app-tabela">
          <div class="box mt-0 mb-5">
            <v-card class="tabela">
              <v-card-title>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Buscar por nome da equipe, CNES ou INE"
                  class="input-bottom"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                @pagination="getPagination"
                :page="currentPage"
                :footer-props="{
                  itemsPerPageText: '',
                  'items-per-page-options': [10],
                  'disable-items-per-page': true,
                }"
                :loading="modal.table.loading"
                loading-text="Carregando, Por favor espere"
                :headers="headers"
                :items="indexedItems"
                :item-class="getRowColor"
                :search="search"
                :single-expand="true"
                :expanded.sync="expanded"
                item-key="index"
                show-expand
                class="elevation-1"
                @item-expanded="onItemExpanded"
              >
                <template v-slot:[`footer.page-text`]="items">
                  <div class="info-table-item tabela-esus-pec">
                    <FonteSincronizadorC />
                  </div>
                  <span class="paginacao"
                    >{{ items.pageStart }} - {{ items.pageStop }} de
                    {{ items.itemsLength }} equipes</span
                  >
                </template>

                <template v-slot:item.nota="{ item }">
                  {{ getValorPrevistoRealizado(item, 'nota') }}
                </template>

                <template v-slot:item.classificacao="{ item }">
                  {{ getValorPrevistoRealizado(item, 'classificacao') }}
                  <span
                    v-if="!isRealizadoSelecionado"
                    v-b-tooltip.html.hover
                    :title="getTextoClassificacaoTooltip(item)"
                    class="icon-tooltip"
                  >
                    <i class="icofont-info-circle"></i>
                  </span>
                </template>

                <template v-slot:expanded-item="{ headers, item }">
                  <td colspan="7">
                    <table class="table table-interna">
                      <thead>
                        <tr>
                          <th>Indicador</th>
                          <th>Peso</th>
                          <th>Numerador</th>
                          <th>Denominador</th>
                          <th>Pontuação</th>
                          <th>Nota</th>
                          <th>Classificação</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item2, index) in item.all_indicadores"
                          :key="index"
                        >
                          <td>
                            {{ item2.ds_indicador }}
                          </td>
                          <td>
                            {{ item2.peso }}
                          </td>
                          <td>
                            <div v-if="item2.indicador == 47">-</div>
                            <div v-else-if="!isRealizadoSelecionado">
                              {{ getValorIndicador(item2, 'numerador') }}
                              <span
                                v-b-tooltip.html.hover
                                :title="
                                  getTooltipsTexts(item2.indicador).numerador
                                "
                                class="icon-tooltip"
                              >
                                <i class="icofont-info-circle"></i>
                              </span>
                            </div>
                            <div v-else>-</div>
                          </td>
                          <td>
                            <div v-if="!isRealizadoSelecionado">
                              {{ getValorIndicador(item2, 'denominador') }}
                              <span
                                v-b-tooltip.html.hover
                                :title="
                                  getTooltipsTexts(item2.indicador).denominador
                                "
                                class="icon-tooltip"
                              >
                                <i class="icofont-info-circle"></i>
                              </span>
                            </div>
                            <div v-else>-</div>
                          </td>
                          <td>
                            {{
                              getValorIndicadorPrevistoRealizado(
                                item,
                                item2,
                                'resultado'
                              )
                            }}
                            <span
                              v-b-tooltip.html.hover
                              v-bind:title="
                                getTooltipsTexts(item2.indicador).resultado
                              "
                              class="icon-tooltip"
                            >
                              <i class="icofont-info-circle"></i>
                            </span>
                          </td>
                          <td>
                            {{
                              getValorIndicadorPrevistoRealizado(
                                item,
                                item2,
                                'nota'
                              )
                            }}
                          </td>
                          <td>
                            <template v-if="!isRealizadoSelecionado">
                              <TextoClassificacaoIndicador
                                :classificacao="
                                  getValorIndicador(item2, 'classificacao')
                                "
                                :idIndicador="item2.indicador"
                                :resultado="
                                  getValorIndicador(item2, 'resultado')
                                "
                              />
                            </template>

                            <template v-else>
                              {{
                                getValorIndicadorPrevistoRealizado(
                                  item,
                                  item2,
                                  'classificacao'
                                )
                              }}
                            </template>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </template>

                <template v-slot:progress>
                  <v-progress-linear
                    color="blue"
                    :height="10"
                    indeterminate
                  ></v-progress-linear>
                </template>
                <template v-slot:no-data>
                  <div class="alert alert-info mb-0">
                    <b
                      >Nenhuma informação encontrada. Selecione outro filtro.</b
                    >
                  </div>
                </template>
                <template v-slot:no-results style="padding: 0px">
                  <div class="alert alert-info mb-0">
                    <b
                      >Nenhuma informação encontrada. Selecione outro filtro.</b
                    >
                  </div>
                </template>
              </v-data-table>
            </v-card>
          </div>
        </v-app>
      </b-modal>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import DonutChart from './DonutChart.vue'
import TreeMap from './TreeMap.vue'
import TextoClassificacaoIndicador from '@/components/utils/TextoClassificacaoIndicador'
import ResultadoToggle from './ResultadoToggle.vue'
import FiltroPrevistoRealizado from './FiltroPrevistoRealizado.vue'
import utils from '@/mixins/utils.js'

export default {
  components: {
    apexchart: VueApexCharts,
    DonutChart,
    TreeMap,
    TextoClassificacaoIndicador,
    ResultadoToggle,
    FiltroPrevistoRealizado,
  },
  props: {
    dadosDashboard: {
      type: Array,
      default: () => {},
    },
    periodo: {
      type: Object,
      default: () => {},
    },
    tipoEquipe: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [utils],
  data() {
    return {
      search: '',
      headers: [
        {
          text: 'CNES',
          align: 'start',
          filterable: true,
          value: 'nu_cnes',
        },
        {
          text: 'UBS',
          align: 'start',
          filterable: true,
          value: 'no_ubs',
        },
        {
          text: 'INE',
          align: 'start',
          filterable: true,
          value: 'ine',
        },
        {
          text: 'Equipe',
          align: 'start',
          filterable: true,
          value: 'no_equipe',
        },
        {
          text: 'Nota',
          align: 'start',
          sortable: false,
          filterable: false,
          value: 'nota',
        },
        {
          text: 'Classificação',
          align: 'start',
          sortable: false,
          filterable: false,
          value: 'classificacao',
        },
        { text: '', value: 'data-table-expand' },
      ],
      currentPage: 1,
      expanded: [],
      modal: {
        title: '',
        enabled: false,
        dadosMs: '[]',
        table: {
          loading: false,
          data: [],
        },
      },
      tipoResultado: 'quadrimestral',
      filtroResultadoQuadrimestral: 'previsto',
      dadosModalOriginais: [],
    }
  },
  watch: {
    filtroResultadoQuadrimestral() {
      this.aplicarFiltroPrevistoRealizado()
    },
  },
  computed: {
    indexedItems() {
      return this.modal.table.data.map((item, index) => {
        return {
          index: index,
          ...item,
        }
      })
    },

    exibirFiltroPrevistoRealizado() {
      if (!this.periodo) {
        return false
      }

      const mes = Number(this.periodo.value.split('/')[0])

      return [4, 8, 12].includes(mes)
    },

    isRealizadoSelecionado() {
      return (
        this.exibirFiltroPrevistoRealizado &&
        this.filtroResultadoQuadrimestral === 'realizado'
      )
    },

    tipoEquipeLabel() {
      if (!this.tipoEquipe || this.tipoEquipe.length === 0) {
        return 'Todas'
      }

      return this.tipoEquipe.map((tipo) => tipo.label).join(', ')
    },
  },
  methods: {
    /**
     * Retorna o valor do campo para o resultado quadrimestral.
     *
     * @param {Object} item Dados do indicador.
     * @param {String} campo Nome do campo.
     * @returns {*} Valor do campo informado.
     */
    getValorIndicador(item, campo) {
      return item[campo] ?? '-'
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Manipula o evento de expansão de um item da tabela.
     * @param {Object} ctx Contexto do item expandido
     */
    onItemExpanded(item) {},

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item
     * @returns {String}
     */
    getRowColor(item) {},

    /**
     * Retorna o texto do tooltip da classificação da equipe.
     *
     * @param {Object} item Dados da equipe.
     * @returns {String|null} Texto do tooltip.
     */
    getTextoClassificacaoTooltip(item) {
      const lista = this.$store.state.regrasIndicadoresAps || []

      // Se for Regular, pode ter vários registros
      const itens =
        item.classificacao === 'Regular'
          ? lista.filter(
              (i) =>
                i.id_indicador == item.indicador &&
                i.classificacao === item.classificacao
            )
          : [
              lista.find(
                (i) =>
                  i.id_indicador == item.indicador &&
                  i.classificacao === item.classificacao
              ),
            ].filter(Boolean)

      if (!itens.length) return null

      const partesParametro = itens
        .map((item) => {
          const partes = []

          if (item.sinal_min && item.min_val) {
            partes.push(`${item.sinal_min} ${item.min_val}`)
          }

          if (item.sinal_max && item.max_val) {
            partes.push(`${item.sinal_max} ${item.max_val}`)
          }

          // Se vierem os dois no mesmo registro, junta com " e "
          return partes.join(' e ')
        })
        .filter(Boolean)

      const parametro = partesParametro.join(' e ')

      const ref = itens[0]

      return `Peso: ${ref.peso} <br>
              Nota: ${item.nota} ${parametro} <br>
              Classificação: ${ref.classificacao} `
    },

    /**
     * Abre o modal com as equipes da classificação selecionada.
     *
     * @param {Object} item Dados da classificação selecionada no gráfico.
     */
    openModal(item) {
      this.currentPage = 1
      this.expanded = []
      this.search = ''
      this.tipoResultado = 'quadrimestral'
      this.filtroResultadoQuadrimestral = 'previsto'
      this.modal.enabled = true
      this.modal.title = item.x

      const dadosTabela = this.dadosDashboard.find((el) => {
        return el.classificacao == item.x
      })

      if (dadosTabela != undefined) {
        this.modal.dadosMs = dadosTabela.dados_ms || '[]'
        this.dadosModalOriginais = JSON.parse(dadosTabela.equipes) ?? []
        this.aplicarFiltroPrevistoRealizado()
      }
    },

    /**
     * Busca os dados realizados da equipe pelo INE dentro da lista dados_ms.
     *
     * @param {Object} equipe Dados previstos da equipe.
     * @returns {Object|null} Dados realizados da equipe ou null.
     */
    getRealizadoEquipe(equipe) {
      if (!equipe?.ine) {
        return null
      }

      const dadosMsLista = this.parseObjectJson(this.modal.dadosMs || '[]')

      return dadosMsLista.find((item) => item?.ine === equipe.ine) || null
    },

    /**
     * Retorna o valor previsto ou previsto / realizado para a tabela principal.
     *
     * @param {Object} item Dados da equipe.
     * @param {String} campo Campo desejado.
     * @returns {*} Valor formatado para exibição.
     */
    getValorPrevistoRealizado(item, campo) {
      const previsto = item[campo] ?? '-'

      if (!this.isRealizadoSelecionado) {
        return previsto
      }

      return `${previsto} / ${item.dadosMs?.[campo] ?? '-'}`
    },

    /**
     * Busca nos dados realizados o indicador correspondente ao indicador previsto.
     *
     * @param {Object} item Dados da equipe.
     * @param {Number|String} indicador Código do indicador.
     * @returns {Object|null} Indicador realizado correspondente ou null.
     */
    getIndicadorRealizado(item, indicador) {
      if (!item.dadosMs || !Array.isArray(item.dadosMs.all_indicadores)) {
        return null
      }

      return (
        item.dadosMs.all_indicadores.find(
          (el) => Number(el.indicador) === Number(indicador)
        ) || null
      )
    },

    /**
     * Retorna o valor previsto ou previsto / realizado para a tabela interna.
     *
     * @param {Object} item Dados da equipe.
     * @param {Object} indicadorPrevisto Indicador previsto.
     * @param {String} campo Campo desejado.
     * @returns {*} Valor formatado para exibição.
     */
    getValorIndicadorPrevistoRealizado(item, indicadorPrevisto, campo) {
      const previsto = this.getValorIndicador(indicadorPrevisto, campo)

      if (!this.isRealizadoSelecionado) {
        return previsto
      }

      const indicadorRealizado = this.getIndicadorRealizado(
        item,
        indicadorPrevisto.indicador
      )

      const realizado = indicadorRealizado
        ? this.getValorIndicador(indicadorRealizado, campo)
        : '-'

      return `${previsto} / ${realizado}`
    },

    /**
     * Aplica a estrutura necessária para exibir Previsto/Realizado no modal.
     *
     * Mantém os dados previstos da equipe e adiciona os dados realizados
     * na propriedade dadosMs, permitindo a exibição no formato previsto / realizado.
     *
     * @returns {void}
     */
    aplicarFiltroPrevistoRealizado() {
      this.modal.table.data = this.dadosModalOriginais.map((equipe) => {
        return {
          ...equipe,
          dadosMs: this.getRealizadoEquipe(equipe),
        }
      })
    },

    /**
     * Retorna os textos utilizados nos tooltips de um indicador.
     *
     * @param {Number} idIndicador Identificador do indicador.
     * @returns {Object|String} Objeto contendo os textos do tooltip.
     */
    getTooltipsTexts(idIndicador) {
      const nomesIndicadores = {
        46: {
          numerador:
            'Total de atendimentos por demanda programada (consulta agendada programada; cuidado continuado; e consulta agendada).',
          denominador:
            'Total de atendimentos por todos os tipos de demandas (espontâneas e programadas).',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: <= 10 ou > 70',
            'Suficiente: > 10 e <= 30',
            'Bom: > 30 e <= 50',
            'Ótimo: > 50 e <= 70',
          ],
        },
        51: {
          numerador:
            'Somatório da(s) boa(s) prática(s) pontuada(s) durante o acompanhamento do desenvolvimento infantil.',
          denominador:
            'Total de crianças com idade igual a 2 (dois) anos completos.',
          resultado: 'Numerador / Denominador',
          classificacao: [
            'Regular: <= 25',
            'Suficiente: > 25 e <= 50',
            'Bom: > 50 e <= 75',
            'Ótimo: > 75 e <= 100',
          ],
        },
        52: {
          numerador:
            'Somatório da(s) boa(s) prática(s) pontuada(s) durante o acompanhamento de uma pessoa gestante e puérpera.',
          denominador:
            'Total de mulheres com encerramento de puerpera no quadrimestre avaliado.',
          resultado: 'Numerador / Denominador',
          classificacao: [
            'Regular: <= 25',
            'Suficiente: > 25 e <= 50',
            'Bom: > 50 e <= 75',
            'Ótimo: > 75 e <= 100',
          ],
        },
        48: {
          numerador:
            'Somatório da(s) boa(s) prática(s) pontuada(s) durante o acompanhamento da pessoa com diabetes.',
          denominador: 'Total de pessoas com diabetes.',
          resultado: 'Numerador / Denominador',
          classificacao: [
            'Regular: <= 25',
            'Suficiente: > 25 e <= 50',
            'Bom: > 50 e <= 75',
            'Ótimo: > 75 e <= 100',
          ],
        },
        50: {
          numerador:
            'Somatório da(s) boa(s) prática(s) pontuada(s) durante o acompanhamento da pessoa com hipertensão arterial.',
          denominador: 'Total de pessoas com hipertensão arterial.',
          resultado: 'Numerador / Denominador',
          classificacao: [
            'Regular: <= 25',
            'Suficiente: > 25 e <= 50',
            'Bom: > 50 e <= 75',
            'Ótimo: > 75 e <= 100',
          ],
        },
        49: {
          numerador:
            'Somatório da(s) boa(s) prática(s) pontuada(s) durante o acompanhamento da pessoa idosa.',
          denominador: 'Total de pessoas idosas.',
          resultado: 'Numerador / Denominador',
          classificacao: [
            'Regular: <= 25',
            'Suficiente: > 25 e <= 50',
            'Bom: > 50 e <= 75',
            'Ótimo: > 75 e <= 100',
          ],
        },
        47: {
          numerador:
            'Somatório da(s) boa(s) prática(s) aplicável(is) para a mulher.',
          denominador: 'Total de mulheres elegíveis na faixa etária.',
          resultado: 'Numerador / Denominador',
          classificacao: [
            'Regular: <= 25',
            'Suficiente: > 25 e <= 50',
            'Bom: > 50 e <= 75',
            'Ótimo: > 75 e <= 100',
          ],
        },
        44: {
          numerador:
            'Total de atendimentos individuais e coletivos realizados pela eMulti no quadrimestre avaliado.',
          denominador: 'Total de pessoas atendidas no quadrimestre avaliado.',
          resultado: 'Numerador / Denominador',
          classificacao: [
            'Regular: <= 1',
            'Suficiente: > 1 e <= 2',
            'Bom: > 2 e <= 3',
            'Ótimo: > 3',
          ],
        },
        45: {
          numerador:
            'Total de ações compartilhadas realizadas pela eMulti no quadrimestre avaliado.',
          denominador: 'Total de ações realizadas pela eMulti.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: <= 1',
            'Suficiente: > 1 e <= 2,5',
            'Bom: > 2,5 e <= 5',
            'Ótimo: > 5',
          ],
        },
        38: {
          numerador:
            'Total de pessoas com atendimentos de primeira consulta odontológica programática.',
          denominador: 'Total de pessoas vinculadas à equipe.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: <= 1',
            'Suficiente: > 1 e <= 3',
            'Bom: > 3 e <= 5',
            'Ótimo: > 5',
          ],
        },
        43: {
          numerador: 'Total de pessoas com tratamento odontológico concluído.',
          denominador:
            'Total de pessoas com primeira consulta odontológica programada.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: <= 25',
            'Suficiente: > 25 e <= 50',
            'Bom: > 50 e <= 75',
            ' Ótimo: > 75 e <= 100',
          ],
        },
        39: {
          numerador: 'Total de exodontias.',
          denominador:
            'Total de procedimentos clínicos individuais preventivos, curativos e exodontias realizados.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: < 8 ou >= 14',
            'Suficiente: >= 12 e < 14',
            'Bom: >= 10 e < 12',
            'Ótimo: >= 8 e < 10',
          ],
        },
        42: {
          numerador:
            'Total de pessoas participantes da ação coletiva de escovação dental supervisionada realizada em crianças com idade entre 6 e 12 anos.',
          denominador: 'Total de pessoas vinculadas à equipe.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: <= 0,25',
            'Suficiente: > 0,25 e <= 0,5',
            'Bom: > 0,5 e <= 1',
            'Ótimo: > 1',
          ],
        },
        40: {
          numerador:
            'Total de procedimentos odontológicos individuais preventivos.',
          denominador:
            'Todos os procedimentos odontológicos individuais registrados.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: < 40 ou > 85',
            'Suficiente: >= 40 e < 60',
            'Bom: >= 60 e < 80',
            'Ótimo: >= 80 e <= 85',
          ],
        },
        41: {
          numerador:
            'Total de procedimentos do tipo Tratamento Restaurador Atraumático.',
          denominador: 'Total de procedimentos restauradores.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: <= 3',
            'Suficiente: > 3 e <= 6',
            'Bom: > 6 e <= 8',
            'Ótimo: > 8',
          ],
        },
        53: {
          numerador: 'Total de gestantes com atendimento odontológico.',
          denominador: 'Total de gestantes da equipe vinculada.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [],
        },
      }

      const indicador = nomesIndicadores[idIndicador]
      if (!indicador) return ''

      return {
        ...indicador,
        classificacao: indicador.classificacao.join('<br>'),
      }
    },
  },
}
</script>

<style lang="scss">
#dashboard-equipes {
  margin: 30px 0;
  h2 {
    font-size: 22px;
  }
}

#dashboard-equipes-modal {
  .modal-filtros {
    gap: 16px;
    flex-wrap: wrap;
  }
}

#dashboard-equipes-modal .tag-tipo-equipe {
  background: #d6d2d2;
  color: #000;
  padding: 5px 10px;
  border-radius: 32px;
  font-size: 13px;
  margin-left: 5px;
  font-weight: 700;
}
</style>
